"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplyDelegationNoPwRequest = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var hsTransfer_1 = require("../../model/hsTransfer");
var service_1 = require("../../../library/base/service");
var ApplyDelegationNoPwRequest = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(ApplyDelegationNoPwRequest, _super);
    function ApplyDelegationNoPwRequest() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '产品购买接口';
        _this.code = '105015';
        _this.desc = '产品购买接口';
        _this.requestParams = new hsTransfer_1.ApplyDelegationNoPwRequestRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return ApplyDelegationNoPwRequest;
}(service_1.BaseService));
exports.ApplyDelegationNoPwRequest = ApplyDelegationNoPwRequest;
//# sourceMappingURL=applyDelegationNoPwRequest.js.map